<template>
  <div>
    <v-dialog v-model="personInvolveDialog" persistent max-width="800px">
      <template v-slot:activator="{ attrs }">
        <p
          id="personInvolveForm"
          v-bind="attrs"
          @click="openPersonInvolveDialog"
        ></p>
      </template>
      <v-card v-if="objForm !== null">
        <v-card-title>
          <span class="text-h5">Tambah Saksi/Korban</span>
        </v-card-title>
        <v-form
          ref="personInvolveFormRef"
          @submit.prevent="savePersonInvolove"
          :disabled="loading || initialreport.status.id != 0"
        >
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="6" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Karyawan/Non Karyawan *
                  </p>
                  <v-autocomplete
                    v-model="objForm.person_type"
                    :items="dropdown.person_type"
                    :rules="rules.personTypeRules"
                    item-text="name"
                    item-value="id"
                    return-object
                    dense
                    outlined
                    clearable
                    style="height: 45px"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="6"></v-col>
                <v-col
                  v-if="
                    objForm != null &&
                    objForm.person_type != null &&
                    objForm.person_type.id == 1
                  "
                  cols="6"
                  class="d-flex flex-column"
                >
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Perusahaan
                  </p>
                  <v-autocomplete
                    @change="companyWatcher"
                    v-model="objForm.company"
                    :items="dropdownData.company"
                    item-text="name"
                    item-value="id"
                    return-object
                    dense
                    outlined
                    clearable
                    style="height: 45px"
                  ></v-autocomplete>
                </v-col>
                <v-col
                  v-if="
                    objForm != null &&
                    objForm.person_type != null &&
                    objForm.person_type.id == 1
                  "
                  cols="6"
                  class="d-flex flex-column"
                >
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Department
                  </p>
                  <v-autocomplete
                    v-model="objForm.department"
                    :items="dropdown.department"
                    :disabled="initialreport.status.id != 0 || objForm.company == null"
                    item-text="name"
                    item-value="id"
                    return-object
                    dense
                    outlined
                    clearable
                    style="height: 45px"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Nama *
                  </p>
                  <v-text-field
                    v-model="objForm.name"
                    :rules="rules.nameRules"
                    dense
                    outlined
                    style="height: 45px"
                  />
                </v-col>
                <v-col cols="4" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    No. Identitas *
                  </p>
                  <v-text-field
                    v-model="objForm.no_identitas"
                    :rules="rules.noIdentitasRules"
                    dense
                    outlined
                    style="height: 45px"
                  />
                </v-col>
                <v-col cols="4" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Tgl. Lahir
                  </p>
                  <v-text-field
                    v-model="objForm.birth_date"
                    type="date"
                    dense
                    outlined
                    style="height: 45px"
                  />
                </v-col>
                <v-col cols="4" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Jenis Kelamin *
                  </p>
                  <v-autocomplete
                    v-model="objForm.gender"
                    :items="dropdown.gender"
                    :rules="rules.genderRules"
                    item-text="name"
                    item-value="id"
                    return-object
                    dense
                    outlined
                    clearable
                    style="height: 45px"
                  ></v-autocomplete>
                </v-col>

                <v-col
                  v-if="
                    objForm != null &&
                    objForm.person_type != null &&
                    objForm.person_type.id == 1
                  "
                  cols="12"
                  class="d-flex flex-column"
                >
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Atasan
                  </p>

                  <v-autocomplete
                    v-model="objForm.employee_leader"
                    :items="dropdown.employee"
                    :search-input.sync="searchEmployee"
                    item-text="name"
                    item-value="id"
                    return-object
                    dense
                    outlined
                    clearable
                    style="height: 45px"
                  >
                    <template v-slot:item="data">
                      <template>
                        <v-list-item-avatar>
                          <img :src="`${data.item.photo}`" />
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ data.item.name }}
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            {{ data.item.company_name }}-{{ data.item.nik }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                    </template>
                  </v-autocomplete>
                </v-col>

                <v-col cols="6" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Keterlibatan *
                  </p>
                  <v-autocomplete
                    v-model="objForm.engagement_type"
                    :items="dropdown.engagement_type"
                    :rules="rules.engagementTypeRules"
                    item-text="name"
                    item-value="id"
                    return-object
                    dense
                    outlined
                    clearable
                    style="height: 45px"
                  ></v-autocomplete>
                </v-col>
                <v-col
                  v-if="
                    objForm != null &&
                    objForm.engagement_type != null &&
                    objForm.engagement_type.id == 1
                  "
                  cols="6"
                  class="d-flex flex-column"
                >
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Kategori Cidera *
                  </p>
                  <v-autocomplete
                    v-model="objForm.injured_category"
                    :items="dropdown.category"
                    :rules="rules.injuredCategoryRules"
                    item-text="name"
                    item-value="id"
                    return-object
                    dense
                    outlined
                    clearable
                    style="height: 45px"
                  ></v-autocomplete>
                </v-col>
                <v-col
                  v-if="
                    objForm != null &&
                    objForm.engagement_type != null &&
                    objForm.engagement_type.id == 1
                  "
                  cols="12"
                  class="d-flex flex-column"
                >
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Bagian Tubuh yang Cidera *
                  </p>
                  <v-autocomplete
                    v-model="objForm.injured_body_part_id"
                    :items="dropdownData.body_part"
                    :rules="rules.injuredBodyPartRules"
                    item-text="name"
                    item-value="id"
                    return-id
                    dense
                    outlined
                    clearable
                    small-chips
                    deletable-chips
                    multiple
                    cache-items
                    style="height: 45px"
                  ></v-autocomplete>
                  <!-- <v-autocomplete
                    v-model="objForm.injured_body_part"
                    :items="dropdown.body_part"
                    :rules="rules.injuredBodyPartRules"
                    item-text="name"
                    item-value="id"
                    return-object
                    dense
                    outlined
                    clearable
                    style="height: 45px"
                  ></v-autocomplete> -->
                </v-col>
                <v-col
                  v-if="
                    objForm != null &&
                    objForm.engagement_type != null &&
                    objForm.engagement_type.id == 1
                  "
                  cols="6"
                  class="d-flex flex-column"
                >
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Mesin yang Digunakan
                  </p>
                  <v-text-field
                    v-model="objForm.machine_used"
                    dense
                    outlined
                    style="height: 45px"
                  />
                </v-col>
                <v-col
                  v-if="
                    objForm != null &&
                    objForm.engagement_type != null &&
                    objForm.engagement_type.id == 1
                  "
                  cols="6"
                  class="d-flex flex-column"
                >
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Jumlah Kerugian
                  </p>
                  <v-text-field
                    v-model="objForm.amount_loss"
                    type="number"
                    :min="0"
                    dense
                    outlined
                    style="height: 45px"
                  />
                </v-col>
                <v-col
                  v-if="
                    objForm != null &&
                    objForm.engagement_type != null &&
                    objForm.engagement_type.id == 1
                  "
                  cols="6"
                  class="d-flex flex-column"
                >
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Lama Rehabilitasi (Hari)
                  </p>
                  <v-text-field
                    v-model="objForm.rehabilitation_days"
                    dense
                    outlined
                    :disabled="false"
                    style="height: 45px"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="red darken-1"
              :loading="loading"
              text
              type="button"
              @click="cancelSave"
            >
              Close
            </v-btn>
            <v-btn color="blue darken-1" :loading="loading" text type="submit">
              Save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import buildType from '../../../../../services/buildType'
export default {
  name: 'FormPersonInvolve',
  props: ['loading', 'personInvolveUpdateForm', 'dropdownData', 'initialreport'],
  data() {
    return {
      dssApi: buildType.apiURL('dss'),
      hrsApi: buildType.apiURL('hrs'),
      search: null,
      selectedEmployee: null,
      searchEmployee: null,
      personInvolveDialog: false,
      objForm: null,
      dropdown: {
        gender: [
          { id: 1, name: 'Laki-laki' },
          { id: 2, name: 'Perempuan' }
        ],
        person_type: [
          { id: 1, name: 'Karyawan' },
          { id: 2, name: 'Non Karyawan' }
        ],
        engagement_type: [
          { id: 1, name: 'Korban' },
          { id: 2, name: 'Saksi' }
        ],
        category: [],
        body_part: [],
        employee: [],
        department: []
      },
      rules: {
        nameRules: [],
        noIdentitasRules: [],
        birthDateRules: [],
        genderRules: [],
        personTypeRules: [],
        engagementTypeRules: [],
        // employeeLeaderRules: [],
        injuredCategoryRules: [],
        injuredBodyPartRules: []
        // machineUsedRules: [],
        // amountLossRules: [],
        // rehabilitationDaysRules: [],
      }
    }
  },
  computed: {
    ...mapGetters(['getUserProfile'])
  },
  watch: {
    searchEmployee(val) {
      if (val !== '') {
        val && val !== this.selectedEmployee && this.querySelections(val)
      } else {
        this.selectedEmployee = null
        this.dropdown.employee = []
      }
    },
    personInvolveUpdateForm(val) {
      console.log('personInvolveUpdateForm changed:', val)
    }
  },
  methods: {
    onResize() {
      this.wWidth = window.innerWidth
    },
    async companyWatcher(p) {
      // console.log(p)
      this.objForm.company = p
      this.getDropdownDepartment(p)
    },
    querySelections(v) {
      let url = `${this.hrsApi}employee/dropdown?keyword=${v}`
      if (this.objForm.company != null) {
        url = url + `&company_id=${this.objForm.company.id}`
      }
      if (this.objForm.department != null) {
        url = url + `&department_id=${this.objForm.department.id}`
      }
      axios
        .get(url)
        .then((res) => {
          console.log('employee>>', res)
          if (res.data.status_code === '00') {
            const resArr = []
            for (let i = 0; i < res.data.data.length; i++) {
              const obj = {
                id: res.data.data[i].id,
                nik: res.data.data[i].nik,
                name: res.data.data[i].name,
                company_id: res.data.data[i].company_id,
                company_name: this.getCompanyAlias(res.data.data[i].company_id),
                photo: res.data.data[i].photo
              }
              resArr.push(obj)
              // =======
              if (this.personInvolveUpdateForm != null) {
                if (this.personInvolveUpdateForm.employee_leader != null) {
                  if (
                    this.personInvolveUpdateForm.employee_leader.id == obj.id &&
                    this.personInvolveUpdateForm.employee_leader.name ==
                      obj.name
                  ) {
                    this.personInvolveUpdateForm.employee_leader = obj
                    // console.log(
                    //   'employee_leader',
                    //   this.personInvolveUpdateForm.employee_leader
                    // )
                  }
                }
              }
            }
            return (this.dropdown.employee = resArr)
          }
          return (this.dropdown.employee = [])
        })
        .catch((err) => {
          this.dropdown.employee = []
          return console.log(err)
        })
    },
    async openPersonInvolveDialog() {
      this.$nextTick(() => {
        console.log('person dialog>>>', this.personInvolveUpdateForm)
      })
      if (this.personInvolveUpdateForm != null) {
        this.objForm = this.personInvolveUpdateForm
        if (this.personInvolveUpdateForm.company != null) {
          this.getDropdownDepartment(this.personInvolveUpdateForm.company)
        }
        if (this.personInvolveUpdateForm.employee_leader != null) {
          this.querySelections(
            this.personInvolveUpdateForm.employee_leader.name
          )
        }
      } else {
        this.objForm = {
          act: 'add',
          name: null,
          birth_date: null,
          gender: null,
          no_identitas: null,
          person_type: null,
          engagement_type: null,
          employee_leader: null,
          injured_category: null,
          injured_body_part_id: null,
          machine_used: null,
          amount_loss: null,
          rehabilitation_days: null,
          company: null,
          department: null
        }
      }
      this.initDropdown()
      // console.log('objForm', this.objForm)
      setTimeout(() => {
        this.personInvolveDialog = true
      }, 300)
    },
    cancelSave() {
      // console.log('cancelSave')
      setTimeout(() => {
        this.$emit('savePersonInvolve', null)
        this.closePersonInvolveDialog()
      }, 0)
    },
    closePersonInvolveDialog() {
      this.$refs.personInvolveFormRef.reset()
      setTimeout(() => {
        this.personInvolveDialog = false
        setTimeout(() => {
          this.objForm = null
          this.dropdown.category = []
          this.dropdown.employee = []
          this.dropdown.department = []
        }, 200)
      }, 200)
    },
    savePersonInvolove() {
      this.rules.nameRules = [(v) => !!v || 'Kolom nama wajib di isii']
      // this.rules.birthDateRules = [
      //   (v) => !!v || 'Kolom tanggal lahir wajib di isii'
      // ]
      this.rules.genderRules = [
        (v) => !!v || 'Kolom jenis kelamin wajib di isii'
      ]
      this.rules.noIdentitasRules = [
        (v) => !!v || 'Kolom no identitas wajib di isii'
      ]
      this.rules.personTypeRules = [
        (v) => !!v || 'Kolom karyawan/non karyawan wajib di isii'
      ]
      this.rules.engagementTypeRules = [
        (v) => !!v || 'Kolom keterlibatan wajib di isii'
      ]
      if (
        this.objForm.engagement_type != null &&
        this.objForm.engagement_type.id == 1
      ) {
        this.rules.injuredCategoryRules = [
          (v) => !!v || 'Kolom kategori cidera wajib di isii'
        ]
        this.rules.injuredBodyPartRules = [
          (v) => !!v || 'Kolom bagian tubuh cidera wajib di isii'
        ]
      }

      const self = this
      setTimeout(function () {
        if (self.$refs.personInvolveFormRef.validate()) {
          const newForm = {}
          Object.assign(newForm, self.objForm)
          self.$emit('savePersonInvolve', newForm)
          self.closePersonInvolveDialog()
        }
      })
    },
    initDropdown() {
      this.getDropdownInjuredCategory()
      // this.getDropdownEmployee()
    },
    getDropdownInjuredCategory() {
      const url = `${this.dssApi}master/universal/injuredcategory/dropdown?keyword=`
      axios
        .get(url)
        .then((res) => {
          if (res.data.status_code === '00') {
            this.dropdown.category = res.data.data
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    async getDropdownDepartment(p) {
      if (p == null) {
        return (this.dropdown.department = [])
      }
      await axios
        .get(
          `${this.hrsApi}master/universal/department/dropdown?filter=[{"company_id":${p.id}}]`
        )
        .then((res) => {
          if (res.data.status_code === '00') {
            return (this.dropdown.department = res.data.data)
          }
          return (this.dropdown.department = [])
        })
        .catch((err) => {
          console.log(err)
          return (this.dropdown.department = [])
        })
    },
    getCompanyAlias(id) {
      switch (id) {
        case 1:
          return 'TMP'
        case 2:
          return 'IMP'
        case 3:
          return 'GIT'
        case 4:
          return 'KAJ'
        case 5:
          return 'WIM'
        case 6:
          return 'SMI'
        case 7:
          return 'THP'
        case 8:
          return 'GAI'
        case 9:
          return 'GPP'
        case 10:
          return 'BWN'
        case 11:
          return 'INO'
        case 12:
          return 'BPS'
        case 13:
          return 'BPC'
        case 14:
          return 'WIMS'
        case 15:
          return 'BWI'
        case 16:
          return 'DAM'
        case 17:
          return 'PSR'
        case 18:
          return 'GAP'
        case 19:
          return 'SKH'
        case 20:
          return 'PTI'
        case 21:
          return 'BMS'
        case 22:
          return 'SDA'
      }
    }
  }
}
</script>
